import { Controller } from "@hotwired/stimulus"
import { apiJson } from "../lib/api_errore"

// PreferencesDialog di Grants.js. All'apertura GET /api/me/alert-prefs (spinner finché non arriva; se fallisce resta lo
// spinner e «Salva» spento, come l'originale), poi interruttore e settori; «Salva preferenze» invia PUT
// { reopening_enabled, sectors, grant_ids } (i grant_ids della campanella tornano com'erano) e chiude la finestra.
const ATTIVO = ["bg-blue-600", "text-white", "border-blue-600"]
const SPENTO = ["bg-white", "text-zinc-600", "border-zinc-300", "hover:border-blue-400"]

export default class extends Controller {
  static targets = ["attesa", "contenuto", "interruttore", "settori", "salva", "rotella", "etichetta"]
  static values = { url: String }

  async carica() {
    this.prefs = null
    this.attesaTarget.hidden = false
    this.contenutoTarget.hidden = true
    this.salvaTarget.disabled = true
    try {
      const prefs = await apiJson(this.urlValue)
      this.prefs = prefs
      this.disegna()
    } catch (_) {
      this.prefs = null
    }
  }

  disegna() {
    const p = this.prefs
    p.sectors = p.sectors || []
    const stato = p.reopening_enabled ? "checked" : "unchecked"
    const sw = this.interruttoreTarget
    sw.dataset.state = stato
    sw.setAttribute("aria-checked", String(!!p.reopening_enabled))
    sw.querySelector("[data-switch-target='thumb']").dataset.state = stato
    this.settoriTarget.replaceChildren(...(p.available_sectors || []).map((s) => this.chip(s)))
    this.attesaTarget.hidden = true
    this.contenutoTarget.hidden = false
    this.salvaTarget.disabled = false
  }

  chip(s) {
    const b = document.createElement("button")
    b.type = "button"
    b.dataset.testid = `pref-sector-${s}`
    b.dataset.settore = s
    b.className = "px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors"
    b.textContent = s
    b.addEventListener("click", () => this.alterna(s, b))
    this.stile(b, this.prefs.sectors.includes(s))
    return b
  }

  stile(b, on) {
    b.classList.remove(...ATTIVO, ...SPENTO)
    b.classList.add(...(on ? ATTIVO : SPENTO))
  }

  alterna(s, b) {
    const p = this.prefs
    p.sectors = p.sectors.includes(s) ? p.sectors.filter((x) => x !== s) : [...p.sectors, s]
    this.stile(b, p.sectors.includes(s))
  }

  async salva() {
    if (!this.prefs || this.salvando) return
    this.salvando = true
    this.salvaTarget.disabled = true
    this.rotellaTarget.hidden = false
    this.etichettaTarget.hidden = true
    try {
      const on = this.interruttoreTarget.dataset.state === "checked"
      await apiJson(this.urlValue, { method: "PUT", body: { reopening_enabled: on, sectors: this.prefs.sectors, grant_ids: this.prefs.grant_ids || [] } })
      window.toast?.success("Preferenze avvisi salvate")
      window.dispatchEvent(new CustomEvent("dialog:close", { detail: { id: "preferenze-avvisi" } }))
    } catch (_) {
      window.toast?.error("Errore nel salvataggio")
    } finally {
      this.salvando = false
      this.salvaTarget.disabled = false
      this.rotellaTarget.hidden = true
      this.etichettaTarget.hidden = false
    }
  }
}
